import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { PostGetResult, SocialLearningPostGet } from 'src/app/_models';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { SocialLearningService } from 'src/app/_services';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji/public_api';

@Component({
  selector: 'app-whatsapp-view',
  templateUrl: './whatsapp-view.component.html',
  styleUrls: ['./whatsapp-view.component.scss']
})
export class WhatsappViewComponent extends BaseComponent implements OnInit, OnChanges {
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    suppressScrollY: false
  };
  @Input()
  activeNote: PostGetResult = null;
  @ViewChild('commentsContainer') private commentsContainer: ElementRef;
  comments: SocialLearningPostGet = {
    results: [],
    totalRecords: 0
  };
  pageSize: number = 6;
  pageIndex: number = 1;
  isOpenedEmoji: boolean = false;
  isActive: boolean = false;
  postComment: string = null;
  constructor(private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeNote !== undefined) {
      this.viewInit();
    }
  }
  viewInit(): void {
    this.comments = {
      results: [],
      totalRecords: 0
    };
    this.pageIndex = 1;
    if (this.activeNote) this.getNoteComments();
  }
  getNoteComments(): void {
    this.isActive = true;
    this.socialLearningService.GetComment(this.activeNote.postId, this.pageSize, this.pageIndex).subscribe(
      (data: SocialLearningPostGet) => {
        if (this.pageIndex === 1) {
          data.results.reverse();
          this.comments.results = data.results;
          setTimeout(() => {
            this.scrollToBottom();
          });
        } else {
          data.results.map(item => this.comments.results.splice(0, 0, item));
          this.commentsContainer.nativeElement.scrollTop = 5;
        }
        this.comments.totalRecords = data.totalRecords;
        this.isActive = false;
      },
      () => {
        this.isActive = false;
      }
    );
  }
  openEmoji(): void {
    this.isOpenedEmoji = !this.isOpenedEmoji;
  }
  emojiSelection(emojiEvent: EmojiEvent): void {
    if (emojiEvent.emoji.unified !== '1F595-1F3FB') {
      if (this.postComment) this.postComment += ' ' + emojiEvent.emoji.native;
      else this.postComment = emojiEvent.emoji.native;
      this.isOpenedEmoji = false;
    }
  }
  comment(keyEvent: KeyboardEvent, isButton: boolean): void {
    if ((keyEvent.keyCode === 13 || isButton) && this.postComment !== null && this.postComment !== '') {
      this.socialLearningService
        .CreateComment({
          postId: this.activeNote.postId,
          postItemId: this.activeNote.postItemId,
          postItemText: this.postComment
        })
        .subscribe(
          (data: PostGetResult) => {
            this.comments.results.push(data);
            this.comments.totalRecords += 1;
            this.postComment = null;
            this.isOpenedEmoji = false;
            setTimeout(() => {
              this.scrollToBottom();
            });
          },
          () => {}
        );
    }
  }
  scrolling(): void {
    if (this.comments.totalRecords > this.comments.results.length) {
      if (this.commentsContainer.nativeElement.scrollTop === 0) {
        this.pageIndex += 1;
        this.getNoteComments();
      }
    }
  }
  scrollToBottom(): void {
    this.commentsContainer.nativeElement.scrollTop = this.commentsContainer.nativeElement.scrollHeight;
  }
  downloadAttachment(attachmentFileName: string): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = this.getImage(attachmentFileName);
    a.target = '_blank';
    a.download = attachmentFileName;
    a.click();
    document.body.removeChild(a);
  }
  getClasses(): string {
    return this.settings.rtl ? 'mat-menu-tia-2 full-width rtl' : 'mat-menu-tia-2 full-width';
  }
}
